// Confronto della build in uso con quella pubblicata, leggendo /asset-manifest.json (CRA).
// Nessuna chiamata al backend: il file e statico e servito dalla stessa origine.
export const MANIFEST_URL = '/asset-manifest.json';
export const VERSION_CHECK_INTERVAL = 10 * 60 * 1000; // 10 minuti

// Estrae l'id build dal manifest. In anteprima (dev server) il bundle non ha hash: niente id.
export const parseBuildId = (manifest) => {
  const main = manifest && manifest.files && manifest.files['main.js'];
  if (typeof main !== 'string') return null;
  const m = main.match(/main\.([a-f0-9]{8,})\.js$/);
  return m ? m[1] : null;
};

// Mostra l'avviso solo se entrambi gli id esistono e sono diversi (durante la pubblicazione
// la fetch fallisce o non torna un id valido: in quel caso nessun banner).
export const isNewVersion = (current, fetched) =>
  Boolean(current) && Boolean(fetched) && current !== fetched;

export const fetchBuildId = async () => {
  try {
    const res = await fetch(`${MANIFEST_URL}?t=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) return null;
    return parseBuildId(await res.json());
  } catch (e) {
    return null;
  }
};
